import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInkManufacturers } from 'b2b-apps/shop/catalog/redux/inkFinder/actionCreators';
import { getInkManufacturers } from 'b2b-apps/shop/catalog/redux/inkFinder/selectors';
import { InkManufacturersType } from 'b2b-apps/shop/catalog/redux/inkFinder/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';

export function useInkFinderManufacturersData(): RemoteRecord<InkManufacturersType> {
  const dispatch = useDispatch();
  const inkManufacturers = useSelector(getInkManufacturers);

  useEffect(
    (): void => {
      dispatch(fetchInkManufacturers());
    },
    [dispatch],
  );

  return inkManufacturers;
}
